import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Box, Typography } from '@material-ui/core';

const RMSSignaturePad = forwardRef(
  ({ height = 180, placeholder = 'Sign here', className = '', onChange }, ref) => {
    const signatureRef = useRef(null);
    const [isEmpty, setIsEmpty] = useState(true);

    const handleBegin = () => {
      if (isEmpty) {
        setIsEmpty(false);
        onChange?.(false);
      }
    };

    useImperativeHandle(ref, () => ({
      clear() {
        signatureRef.current?.clear();
        setIsEmpty(true);
        onChange?.(true);
      },

      isEmpty() {
        return signatureRef.current?.isEmpty();
      },

      getSignature() {
        if (signatureRef.current?.isEmpty()) {
          return null;
        }

        return signatureRef.current?.getTrimmedCanvas()?.toDataURL('image/png');
      },

      fromDataURL(data) {
        signatureRef.current?.fromDataURL(data);
        setIsEmpty(false);
        onChange?.(false);
      },
    }));

    return (
      <Box className={`rms-signature-pad ${className}`} style={{ height }}>
        <SignatureCanvas
          ref={signatureRef}
          penColor="black"
          onBegin={handleBegin}
          canvasProps={{
            className: 'rms-signature-canvas',
          }}
        />

        {isEmpty && <Typography className="signature-placeholder">{placeholder}</Typography>}
      </Box>
    );
  }
);

export default RMSSignaturePad;
